/* eslint-disable padded-blocks */
/* eslint-disable keyword-spacing */
import StorageManager from "./StorageManager";

export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL ?? "";

const isJsonString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

/**
 * Returns json body and status
 */
export const getRequest = async ({ url, headers, fullUrl, authorized }) => {
  const res = await fetch(fullUrl ? url : `${BASE_API_URL}${url}`, {
    method: "GET",
    headers: authorized
      ? {
          ...headers,
          Authorization: `Bearer ${StorageManager.get("TOKEN")}`,
        }
      : headers,
  });

  const json = await res.json();
  return { ...json, status: res.status };
};

/**
 * Returns json body and status
 */
export const exportRequest = async ({ url, headers, fullUrl, authorized }) => {
  const res = await fetch(fullUrl ? url : `${BASE_API_URL}${url}`, {
    method: "GET",
    headers: authorized
      ? {
          ...headers,
          Authorization: `Bearer ${StorageManager.get("TOKEN")}`,
        }
      : headers,
  });

  const doc = await res.blob();
  const header = res.headers.get("Content-Disposition");
  const parts = header?.split(";");
  const filename = JSON.parse(parts[1].split("=")[1]);
  const downloadLink = document.createElement("a");
  const blob = new Blob(["\ufeff", doc]);
  const docUrl = URL.createObjectURL(blob);
  downloadLink.href = docUrl;
  downloadLink.download = filename;

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  return { doc, status: res.status };
};
export const exportXlsxRequest = async ({ url, headers, fullUrl, authorized }) => {
  const res = await fetch(fullUrl ? url : `${BASE_API_URL}${url}`, {
    method: "GET",
    headers: authorized
      ? {
          ...headers,
          Authorization: `Bearer ${StorageManager.get("TOKEN")}`,
        }
      : headers,
  });

  const doc = await res.arrayBuffer();
  const header = res.headers.get("Content-Disposition");
  const parts = header?.split(";");
  const filename = parts[1].split("=")[1];
  const downloadLink = document.createElement("a");
  const blob = new Blob([doc], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const docUrl = URL.createObjectURL(blob);
  downloadLink.href = docUrl;
  downloadLink.download = filename;

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
  return { doc, status: res.status };
};

/**
 * Returns json body and status of specified method
 * jsonContentType is added to json when jsonContentType=true
 */
export const request = async ({
  url,
  headers,
  body,
  method,
  fullUrl,
  jsonContentType,
  authorized,
}) => {
  const preHeaders = {};
  if (authorized) {
    preHeaders.Authorization = `Bearer ${StorageManager.get("TOKEN")}`;
  }
  if (jsonContentType) {
    preHeaders["Content-Type"] = "application/json";
  }
  const res = await fetch(fullUrl ? url : `${BASE_API_URL}${url}`, {
    method,
    headers: {
      ...preHeaders,
      ...headers,
    },
    body: body || "",
  });

  // handle server errors
  if (res.status >= 500 && res.status <= 599) {
    return {
      status: res.status,
      message: "An error occurred, please try again later",
    };
  }

  let json = {};
  // handle client errors
  if (res.status >= 400 && res.status <= 499) {
    const plainText = await res.text();
    // check if the text is a json and can be parsed
    if (!isJsonString(plainText)) {
      return {
        status: res.status,
        message: res.statusText,
      };
    }
    json = JSON.parse(plainText);
    return {
      status: res.status,
      message: res.statusText,
      response: json,
    };
  }

  // handle void responses >200 (204 and no json responses)
  if (res.status >= 200 && res.status <= 399) {
    const plainText = await res.text();

    // check if the text is a json and can be parsed
    if (!isJsonString(plainText)) {
      return { message: plainText, status: res.status };
    }

    json = JSON.parse(plainText);
  }

  return { ...json, status: res.status };
};

/**
 * Returns json body and status of post method
 */
export const postRequest = async (props) =>
  request({
    ...props,
    method: "POST",
  });

/**
 * Returns json body and status of put method
 */
export const putRequest = async (props) =>
  request({
    ...props,
    method: "PUT",
  });

/**
 * Returns json body and status of delete method
 */
export const deleteRequest = async (props) =>
  request({
    ...props,
    method: "DELETE",
  });

export default request;
